import authenticationReducer from './authentication/authentication.reducer'
import paymentsReducer from './payments/payments.reducer'
import userReducer from './user/user.reducer'
import userInterfaceReducer from './userInterface/userInterface.reducer'
import nchanSubscriberReducer from './NchanSubscriber/reducer'
import countryReducer from './country/country.reducer'
import languageReducer from './language/language.reducer'
import sportsReducer from './sports/sports.reducer'
import channelThemeReducer from './channelTheme/channelTheme.reducer'
import channelReducer from './channel/channel.reducer'
import streamReducer from './stream/stream.reducer'
import channelFontsReducer from './channelFonts/channelFonts.slice'
import rolesReducer from './roles/roles.reducer'
import permissionsReducer from './permissions/permissions.reducer'
import channelAboutReducer from './channelAbout/channelAbout.slice'
import { location } from './location/location.reducer'
import platformDetectionReducer from './platformDetection/platformDetection.slice'
import notificationReducer from './native/notification/notification.reducer'

export const storeReducer = {
  authentication: authenticationReducer,
  payments: paymentsReducer,
  user: userReducer,
  userInterface: userInterfaceReducer,
  subscriber: nchanSubscriberReducer,
  country: countryReducer,
  language: languageReducer,
  sports: sportsReducer,
  channelTheme: channelThemeReducer,
  channel: channelReducer,
  stream: streamReducer,
  channelFonts: channelFontsReducer,
  roles: rolesReducer,
  permissions: permissionsReducer,
  channelAbout: channelAboutReducer,
  location: location,
  platformDetection: platformDetectionReducer,
  notification: notificationReducer
}
